import { Navigate, Outlet } from 'react-router-dom';
import { isLoginIn } from '@utils/helpers';

export function PrivateRouter() {
  return isLoginIn() ? <Outlet /> : <Navigate to="/?popup=sign-in" />;
}
